var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.916 13.9156V14.1939C14.8286 14.5448 15.5891 15.205 16.0648 16.0593C16.5405 16.9135 16.7013 17.9076 16.5191 18.8683C16.3369 19.829 15.8233 20.6952 15.0679 21.3159C14.3124 21.9367 13.363 22.2726 12.3852 22.265H6.9581C5.99203 22.241 5.06421 21.8825 4.33291 21.2508C3.6016 20.6191 3.11211 19.7532 2.94791 18.8009C2.78372 17.8486 2.955 16.8688 3.43253 16.0286C3.91007 15.1885 4.66428 14.54 5.56653 14.1939V13.9156C5.56653 12.8084 6.00636 11.7465 6.78928 10.9636C7.57219 10.1807 8.63405 9.74084 9.74125 9.74084C10.8485 9.74084 11.9103 10.1807 12.6932 10.9636C13.4761 11.7465 13.916 12.8084 13.916 13.9156Z",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74072 22.2651V30.6146",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0898 26.4399V30.6147",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6987 26.44H28.2488C28.5212 26.4362 28.7864 26.3525 29.0117 26.1993C29.2369 26.0462 29.4123 25.8303 29.516 25.5784C29.6197 25.3265 29.6472 25.0497 29.5951 24.7824C29.543 24.515 29.4136 24.2688 29.2229 24.0743L25.0482 19.4821H25.4656C25.738 19.4783 26.0033 19.3946 26.2285 19.2415C26.4538 19.0883 26.6291 18.8724 26.7329 18.6205C26.8366 18.3687 26.8641 18.0919 26.812 17.8245C26.7599 17.5571 26.6304 17.311 26.4397 17.1164L22.265 12.5243H22.5433C22.8276 12.5499 23.1128 12.4875 23.3604 12.3456C23.608 12.2037 23.806 11.9891 23.9275 11.7308C24.049 11.4726 24.0882 11.1833 24.0397 10.902C23.9913 10.6208 23.8575 10.3612 23.6566 10.1586L18.0903 4.1748L16.1421 6.26217",
    stroke: "#2A2A2A",
    strokeWidth: 2.78315,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.5e725415780f22f94d8a9544172900bb.svg";
export { ForwardRef as ReactComponent };